<!-- 工业园区详情 -->
<template>
  <div class="dialog-industrial">
    <div class="header">
      <div class="title">{{ data.yqmc || '-' }}</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="descriptions-group">
          <h5>基本信息</h5>
          <div class="descriptions-item">
            <span class="key">组团名称:</span>
            <span class="value">{{ data.ztmc || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">园区级别:</span>
            <span class="value">{{ data.yqjb || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">入园企业数:</span>
            <span class="value">{{ data.ryqyjs || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">所在河流:</span>
            <span class="value">{{ data.snstfhl || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">排污去向:</span>
            <span class="value">{{ data.pwqx || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">受纳水体:</span>
            <span class="value">{{ data.snst || '-' }}</span>
          </div>
        </div>
        <div class="descriptions-group three-in-line">
          <h5>已建成集中式污水处理设施</h5>
          <div class="descriptions-item">
            <span class="key">设施数量:</span>
            <span class="value">{{ data.jzwsclsss || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">设计处理能力(t/a):</span>
            <span class="value">{{ data.yqsjclnl || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">实际处理能力(t/a):</span>
            <span class="value">{{ data.yqsjcll || '-' }}</span>
          </div>
        </div>
        <div class="descriptions-group three-in-line">
          <h5>在线装置并联网数</h5>
          <div class="descriptions-item">
            <span class="key">在线监控数:</span>
            <span class="value">{{ data.zcxsw || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">在线监测数:</span>
            <span class="value">{{ data.ymqjxgc || '-' }}</span>
          </div>
          <div class="descriptions-item video"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'
const props = defineProps({
  data: Object,
})
const { data } = toRefs(props)
</script>

<style lang="scss" scoped>
.dialog-industrial {
  width: 54.35rem;
  min-width: 54.35rem;
  .header {
    text-align: left;
    margin-bottom: 5px;
    border-bottom: 1px solid #ddd;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 32px;
      font-size: 16px;
    }
  }
  .body {
    .content {
      margin-bottom: 2rem;
      .descriptions-group {
        overflow: hidden;
        h5 {
          font-size: 14px;
          margin: 10px 0;
          &::before {
            content: '';
            border: 0.5rem solid #e4f2f8;
            border-radius: 50%;
            width: 0.2rem;
            height: 0.8rem;
            box-sizing: border-box;
            margin-right: 0.4rem;
            display: inline-block;
            vertical-align: unset;
          }
        }
        &.three-in-line {
          .descriptions-item {
            width: 33.3%;
            .key {
              width: 10.8rem;
              margin-right: 1rem;
            }
          }
        }
        .descriptions-item {
          width: 50%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          display: flex;
          &:last-of-type {
            margin-bottom: 1.4rem;
          }

          &.video {
            width: 100%;
            height: 30rem;
            background-color: #1f7fa6;
            margin-bottom: 0;
          }
          .key {
            display: inline-block;
            color: #ffffff;
            width: 12.8rem;
            margin-right: 1.9rem;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
